<app-breadcrumb [title]="page_name" [breadcrumb]="page_name" [border]="false" [currentUrl]="currentUrl"  ></app-breadcrumb>
<section class="section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <div class="account-sidebar" (click)="ToggleDashboard()">
                    <a hre="javascript:void(0)" class="popup-btn">
                        {{'Profile' | translate}}
                    </a>
                </div>
                <div class="dashboard-left" [class.open]="openDashboard">
                    <div class="collection-mobile-back" (click)="ToggleDashboard()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> {{'Back' | translate}}
                        </span>
                    </div>
                    <div class="block-content">
                        <ul>
                            <li><a data-lng="es" [routerLink]="'/pages/dashboard'">
                                    {{'address' | translate}}
                                </a>
                            </li>
                            <li class="active"><a data-lng="es" [routerLink]="'/pages/my-orders'">
                                    {{'orders' | translate}}
                                </a>
                            </li>
                            <li><a data-lng="es" [routerLink]="'/pages/my-coupones'">
                                    {{'coupones' | translate}}
                                </a>
                            </li>
                            <li><a data-lng="es" [routerLink]="'/pages/browse-log'">
                                    {{'browse log' | translate}}
                                </a>
                            </li>
                            <li><a data-lng="es" [routerLink]="'/pages/profile'">
                                    {{'my profile' | translate}}
                                </a>
                            </li>
                            <li>
                                <a data-lng="es" href="javascript:void(0)" (click)="userLogOut()">
                                    {{'logout' | translate}}
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="dashboard-right">
                    <div class="dashboard">
                        <!-- <div class="box-head">
                            <h2>{{page_name}}</h2>
                        </div> -->
                        <div class="loader-block" *ngIf="!datadone">
                            <img src="assets/images/loader.gif">
                        </div>
                        <div *ngIf="datadone">
                            <div class="order-details-layout">
                                <div class="order-container">
                                    <div
                                        *ngFor="let history of orderState.history_edit_invoice; let i = index;let first=first">
                                        <div class="order-status-container">
                                            <div class="order-icon-status">
                                                <i class="fa fa-solid fa-check"></i>
                                            </div>
                                            <div class="w-100">
                                                <div class="d-flex justify-content-between w-100">
                                                    <p class="m-0" style=" color: #222;">
                                                        {{history.status|translate}}</p>
                                                    <div class="order-state-date">
                                                        <p class="m-0">{{history.date_added | date:'yyyy/M/d'}}</p>
                                                        <!-- <p class="m-0" *ngIf="common.isRtl">{{history.date_added | dateTime}}</p> -->
                                                        <p class="m-0" style=" color: #222;">{{history.date_added |
                                                            date:'h:mm
                                                            a'}}
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div class="line" [ngStyle]="{'background-color': !first ? '#fcd34d' : ''}">
                                            </div>
                                            <p class="red-text" *ngIf="history.content">{{history.content}}</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="single-item-text-block" *ngIf="orderState?.status">
                                    <div>
                                        <span class="single-item-label">
                                            {{'order status' | translate}} :
                                        </span>
                                        <span class="single-item-text">
                                            {{orderState.status | translate}}
                                        </span>
                                    </div>
                                    <div>
                                        <span class="single-item-label">
                                            {{'date of last update' | translate}} :
                                        </span>
                                        <span class="single-item-text">
                                            {{this.orderState?.history_edit_invoice.at(-1).date_added |
                                            date:'MMM d, y, h:mm a'}}
                                        </span>
                                    </div>
                                </div>

                                <div class="single-item-text-block"
                                    *ngIf="orderState?.shipment_info?.shipping_policy_bar_code">
                                    <span class="single-item-label w-100">
                                        {{'Bill of lading number to track shipment' | translate}} :
                                    </span>
                                    <span class="single-item-text code-cell">
                                        <span>
                                            {{orderState?.shipment_info?.shipping_policy_bar_code}}
                                        </span>
                                        <span class="copy-btn"
                                            (click)="copyMessage(orderState?.shipment_info?.shipping_policy_bar_code)">
                                            {{'copy code' | translate}} <i class="fa fa-clone" aria-hidden="true"></i>
                                        </span>
                                    </span>
                                </div>
                                <div class="single-item-text-block d-block" *ngIf="orderState.shipment_company">
                                    <span class="single-item-label">
                                        {{'shipping way' | translate}}:
                                    </span>
                                    <span class="single-item-text">
                                        {{orderState.shipment_company}}
                                    </span>
                                    <img *ngIf="orderState.shipment_info.image" [src]="common._ImageUrl + 'shipping-methods/' + orderState.shipment_info.image"
                                        alt="Shipping Method" width="50" (error)="handleImageError($event)">
                                </div>
                                <div class="single-item-text-block flex-column align-items-start">
                                    <span class="single-item-text">
                                        {{'shipping duration text' | translate}}
                                    </span>
                                    <span *ngIf="expectedDate?.start && expectedDate?.end">
                                      <ng-container  *ngIf="(shippmentInfo?.delivery_time_to - shippmentInfo?.delivery_time_from < 24) && shippmentInfo?.delivery_time_to <= 24; else longDate"
                                      >
                                        {{
                                          "DELIVERY_TIME_SAME_DAY"
                                            | translate
                                              : {
                                                  start:
                                                  shippmentInfo
                                                      ?.delivery_time_from,
                                                  end:shippmentInfo
                                                    ?.delivery_time_to
                                                }
                                        }}
                                      </ng-container>
                                      <ng-template #longDate>
                                        {{
                                          "Expected Delivery Time" | translate
                                        }}

                                        {{ "deliver between" | translate }}

                                        {{
                                            expectedDate.start| date: 'dd/MM/yyyy'
                                        }}
                                        -
                                        {{
                                            expectedDate.end| date: 'dd/MM/yyyy'
                                        }}
                                      </ng-template>

                                      <ng-template #singleDate>
                                        {{
                                            expectedDate?.start
                                            ? (expectedDate.start| date: 'dd/MM/yyyy')
                                            : (expectedDate.end | date: 'dd/MM/yyyy')
                                        }}
                                      </ng-template>
                                    </span>
                                    <span
                                      *ngIf="
                                        (expectedDate?.start && !expectedDate?.end) ||
                                        (!expectedDate?.start && expectedDate?.end)
                                      "
                                    >
                                      <ng-container
                                        *ngIf="
                                          (shippmentInfo
                                            ?.delivery_time_to <= 24 &&
                                            shippmentInfo
                                              ?.delivery_time_from == 0) ||
                                            (shippmentInfo
                                              ?.delivery_time_to == 0 &&
                                              shippmentInfo
                                                ?.delivery_time_from <= 24);
                                          else singleDate
                                        "
                                      >
                                        {{
                                          "DELIVERY_TIME_SAME_DAY_single"
                                            | translate
                                              : {
                                                  time:
                                                    +shippmentInfo
                                                      ?.delivery_time_from != 0
                                                      ? shippmentInfo
                                                          ?.delivery_time_from
                                                      : shippmentInfo
                                                          ?.delivery_time_to
                                                }
                                        }}
                                      </ng-container>

                                      <ng-template #singleDate>
                                        {{
                                          "Expected Delivery Time" | translate
                                        }}

                                        {{
                                            expectedDate?.start
                                            ? (expectedDate.start | date: 'dd/MM/yyyy')
                                            : (expectedDate.end | date: 'dd/MM/yyyy')
                                        }}
                                      </ng-template>
                                    </span>
                                    <span *ngIf="!expectedDate?.start && !expectedDate?.end">
                                      {{ "DELIVERY_TIME_NOT_SET" | translate }}
                                    </span>
                                    <span class="single-item-label" style="color: #000;">
                                        {{'Please pay attention to mobile and WhatsApp' | translate}}
                                    </span>
                                </div>
                                <div class="single-item-text-block flex-column align-items-start"
                                    *ngIf="orderState?.shipment_info?.branch_number || orderState?.shipment_info?.main_branch_number">
                                    <span class="single-item-label">
                                        {{'mobiles of shipping company' | translate}}
                                    </span>
                                    <span class="mt-2 single-item-label" *ngIf="orderState?.branch_number">
                                        {{'brnach of shipping company at Governorate' | translate}}
                                        {{orderState?.city_name}}
                                    </span>
                                    <span class="single-item-label" *ngIf="orderState?.shipment_info?.branch_number">
                                        <span>
                                            {{orderState?.shipment_info?.branch_number}}
                                        </span>
                                        <span class="copy-btn"
                                            (click)="callNumber(orderState?.shipment_info?.branch_number)">
                                            {{'call' | translate}}
                                            <!-- <i class="fa fa-phone" aria-hidden="true"></i> -->
                                        </span>
                                    </span>
                                    <span class="mt-2 single-item-label"
                                        *ngIf="orderState?.shipment_info?.main_branch_number">
                                        {{'contact number of main branch for shipping company' | translate}}
                                    </span>
                                    <span class="single-item-label"
                                        *ngIf="orderState?.shipment_info?.main_branch_number">
                                        <span>
                                            {{orderState?.shipment_info?.main_branch_number}}
                                        </span>
                                        <span class="copy-btn"
                                            (click)="callNumber(orderState?.shipment_info?.main_branch_number)">
                                            {{'call' | translate}}
                                            <!-- <i class="fa fa-phone" aria-hidden="true"></i> -->
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
    <div class="shadow login-sidebar">
        <i class="ti-close login-icon" (click)="close()"></i>
        <app-fast-login (step5Reached)="onStep5Reached()"
            (stepSuccessReached)="onstepSuccessReached()"></app-fast-login>
    </div>
</section>
